"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterGroupType = exports.TestType = void 0;
/* eslint-disable no-unused-vars */
var TestType;
(function (TestType) {
    TestType["Lt"] = "<";
    TestType["LtEq"] = "<=";
    TestType["Eq"] = "=";
    TestType["GtEq"] = ">=";
    TestType["Gt"] = ">";
    TestType["NEq"] = "<>";
    TestType["In"] = "in";
    TestType["NotIn"] = "not in";
    TestType["Like"] = "like";
    TestType["Null"] = "is null";
    TestType["NotNull"] = "is not null";
    TestType["Latest"] = "latest";
    TestType["Earliest"] = "earliest";
})(TestType = exports.TestType || (exports.TestType = {}));
/* eslint-disable no-unused-vars */
var FilterGroupType;
(function (FilterGroupType) {
    FilterGroupType["Or"] = "or";
    FilterGroupType["And"] = "and";
})(FilterGroupType = exports.FilterGroupType || (exports.FilterGroupType = {}));
/* eslint-enable no-unused-vars */ 
